import { lazy } from "react";

export const OrdersSection = lazy(
  () => import("./Orders/OrdersSection/OrdersSection"),
);

export const AllOrders = lazy(
  () => import("./Orders/AllOrders/AllOrders"),
);

export const OngoingOrders = lazy(
  () => import("./Orders/OngoingOrders/OngoingOrders"),
);

export const CompletedOrders = lazy(
  () => import("./Orders/CompletedOrders/CompletedOrders"),
);

export const CancelledOrders = lazy(
  () => import("./Orders/CancelledOrders/CancelledOrders"),
);

export const OrderDetailsV2 = lazy(
  () => import("./Orders/OrderDetails/OrderDetails"),
);

export const RequestsSection = lazy(
  () => import("./Requests/RequestsSection/RequestsSection"),
);

export const AllQuoteRequests = lazy(
  () => import("./Requests/AllQuoteRequests/AllQuoteRequests"),
);

export const QuoteRequestDetails = lazy(
  () => import("./Requests/QuoteRequestDetails/QuoteRequestDetails"),
);

export const PendingQuoteRequests = lazy(
  () =>
    import("./Requests/PendingQuoteRequests/PendingQuoteRequests"),
);

export const ReceivedQuoteRequests = lazy(
  () =>
    import("./Requests/ReceivedQuoteRequests/ReceivedQuoteRequests"),
);

export const RejectedQuoteRequest = lazy(
  () =>
    import("./Requests/RejectedQuoteRequests/RejectedQuoteRequests"),
);

export const AcceptedQuoteRequests = lazy(
  () =>
    import("./Requests/AcceptedQuoteRequests/AcceptedQuoteRequests"),
);

export const SavedSection = lazy(
  () => import("./SavedList/SavedSection/SavedSection"),
);

export const SavedItems = lazy(
  () => import("./SavedList/SavedItems/SavedItems"),
);

export const SavedProperties = lazy(
  () => import("./SavedList/SavedProperties/SavedProperties"),
);

export const TransactionsSection = lazy(
  () =>
    import("./Transactions/TransactionsSection/TransactionsSection"),
);

export const AllTransactions = lazy(
  () => import("./Transactions/AllTransactions/AllTransactions"),
);

export const BuyerHome = lazy(() => import("./BuyerHome/BuyerHome"));
